import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { TopImageZoomSliderModal } from '@/components/modules/pages/top/slider/TopImageZoomSlider/TopImageZoomSliderModal';
import { useTopImageZoomSlider } from '@/components/modules/pages/top/slider/TopImageZoomSlider/useTopImageZoomSlider';
import { ImageBase } from '@/components/ui/Image/ImageBase';
import { SliderBase } from '@/components/ui/Slider/SliderBase';
import { MapsUgcOutlineIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { getScreenValueOfNumber } from '@/utils/style/config';
const setting = {
    arrows: false,
    infinite: false,
    responsive: [
        {
            breakpoint: getScreenValueOfNumber('md') - 1,
            settings: {
                slidesToShow: 1,
                variableWidth: true,
            },
        },
    ],
    slidesToScroll: 1,
    slidesToShow: 3,
    variableWidth: false,
};
export const TopImageZoomSlider = (props) => {
    const { className = '', items } = props;
    // モーダル表示関連の処理
    const { hideModal, isShowModal, modalInitialSlide, onClickSliderItem } = useTopImageZoomSlider();
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: clsx('pl-16 md:px-16 lg:px-4', className) }, { children: _jsx(SliderBase, Object.assign({ setting: setting }, { children: items.map((item, index) => (_jsx("div", Object.assign({ className: 'px-4 lg:px-16' }, { children: _jsxs("button", Object.assign({ className: clsx('relative', 'hover:shadow-lg', 'w-[280px] xs:w-[305px] md:w-full'), onClick: onClickSliderItem, type: 'button', value: index }, { children: [_jsx(ImageBase, { alt: item.alt, imageHeight: item.imageHeight, imageWidth: item.imageWidth, objectPosition: 'contain', src: item.src, webpSrc: item.webpSrc }), _jsx("span", Object.assign({ className: clsx('absolute bottom-12 right-12', 'inline-flex items-center justify-center', 'w-[48px] h-[48px] rounded-full', 'bg-black opacity-60') }, { children: _jsx(MapsUgcOutlineIcon, { color: 'white', size: 'sm' }) }))] })) }), `TopImageZoomSlider_item_${index + 1}`))) })) })), _jsx(TopImageZoomSliderModal, { hideModal: hideModal, initialSlide: modalInitialSlide, isShow: isShowModal, items: items })] }));
};
